<template>
  <v-card class="wrapper table-wrapper d-flex flex-column pa-4 ma-0 gap-1">
    <AppBar
      @get-items="handleGetItems"
      @open-filters="handleFilters"
      @delete-selected="handleDelete"
      :workshop-items="items"
      :delete-show="groupDelete"
    />
    <div
      v-if="initialLoading"
      class="mt-4"
      style="height: calc(100vh - 158px); overflow: hidden"
    ></div>
    <Table
      v-show="!initialLoading"
      @call-refresh="handleChange"
      @initial-Loading-is="handleLoading"
      :call-refresh="refresh"
      :call-group-delete="callGroupDelete"
      :call-delete="callDelete"
      @workshop-items="handleItems"
      @group-delete="handleGroupDelete"
      @close-dialog-permision="closePermision"
      @open-dialog-permision="openPermision"
      class=""
    />
    <WorkshopFilter
      :filter-drawer="openNavigationDrawer"
      @close-filters="handleCloseFilter"
    />
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="groupDelete" color="primary" @click="removegroup()">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="!groupDelete" color="primary" @click="remove()">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Refresh overlay -->
    <v-overlay absolute :value="refresh" opacity="0.1">
      <v-progress-circular indeterminate size="26" width="3" color="primary" />
    </v-overlay>
  </v-card>
</template>

<script>
import AppBar from "@/views/dashboard/pages/payroll/workshop/partial/AppBar.vue";
import Table from "@/views/dashboard/pages/payroll/workshop/partial/Table.vue";
import WorkshopFilter from "./partial/WorkshopFilter.vue";

export default {
  name: "workshop",
  components: {
    AppBar,
    Table,
    WorkshopFilter,
  },
  data: () => ({
    refresh: false,
    groupDelete: false,
    callGroupDelete: false,
    callDelete: false,
    deletDialog: false,
    openNavigationDrawer: false,
    initialLoading: true,
    items: null,
  }),
  mounted() {},
  methods: {
    handleItems(val) {
      this.items = val;
    },
    handleGetItems() {
      this.refresh = true;
      this.initialLoading = false;
    },
    handleChange() {
      this.refresh = false;
    },
    handleFilters() {
      this.openNavigationDrawer = true;
    },
    handleCloseFilter() {
      this.openNavigationDrawer = false;
    },
    handleLoading(val) {
      this.initialLoading = val;
    },
    handleGroupDelete(val) {
      this.groupDelete = val;
    },
    handleDelete() {
      this.deletDialog = true;
    },
    closePermision() {
      this.deletDialog = false;
      this.groupDelete = false;
      this.callGroupDelete = false;
    },
    openPermision() {
      this.deletDialog = true;
    },
    removegroup() {
      this.callGroupDelete = true;
    },
    remove() {
      this.callDelete = true;
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
}
.table-wrapper {
  position: relative;
  min-height: 300px;
}
</style>
